export interface Category {
  slug: string;
  name: string;
  icon: string;
  desc: string;
  cover: string;
}

export const categories: Category[] = [
  {
    slug: "variety",
    name: "综艺名场面",
    icon: "ri-tv-2-line",
    desc: "收官夜、名场面、剪辑节奏，把一档综艺的高光时刻拆开看。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20variety%20show%20stage%20set%20with%20crimson%20velvet%20curtains%20and%20amber%20spotlights%2C%20empty%20set%2C%20soft%20bokeh%2C%20cinematic%20editorial%20photography%2C%20clean%20uncluttered%20background%2C%20high%20detail&width=600&height=600&seq=cat-variety-01&orientation=squarish",
  },
  {
    slug: "screen",
    name: "影视风向",
    icon: "ri-movie-2-line",
    desc: "定档、选角、预告与口碑曲线，跟住剧集和电影的话题节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinema%20screening%20hall%20with%20warm%20golden%20ambient%20light%20and%20rows%20of%20crimson%20seats%2C%20soft%20focus%2C%20cinematic%20editorial%20photography%2C%20clean%20background%2C%20high%20detail&width=600&height=600&seq=cat-screen-01&orientation=squarish",
  },
  {
    slug: "stage",
    name: "舞台现场",
    icon: "ri-live-line",
    desc: "直拍、编舞、走位与灯光，聊的是舞台呈现本身。",
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20dramatic%20warm%20spotlight%20beams%20and%20light%20haze%2C%20no%20people%2C%20silhouette%20of%20stage%20equipment%2C%20cinematic%20editorial%20photography%2C%20clean%20composition&width=600&height=600&seq=cat-stage-01&orientation=squarish",
  },
  {
    slug: "style",
    name: "红毯造型",
    icon: "ri-t-shirt-2-line",
    desc: "配色、剪裁与配饰细节，红毯上的造型观察笔记。",
    cover:
      "https://readdy.ai/api/search-image?query=luxury%20flat%20lay%20of%20fashion%20accessories%20and%20silk%20fabric%20swatches%20in%20crimson%20and%20gold%20on%20warm%20cream%20background%2C%20editorial%20product%20photography%2C%20soft%20shadows&width=600&height=600&seq=cat-style-01&orientation=squarish",
  },
  {
    slug: "music",
    name: "音乐热歌",
    icon: "ri-music-2-line",
    desc: "现场收音、翻唱回潮与歌单变化，聊聊歌是怎么又火起来的。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20microphone%20and%20headphones%20on%20warm%20wooden%20surface%20with%20amber%20rim%20light%2C%20cinematic%20editorial%20still%20life%20photography%2C%20clean%20simple%20background&width=600&height=600&seq=cat-music-01&orientation=squarish",
  },
  {
    slug: "meme",
    name: "网络热梗",
    icon: "ri-chat-smile-2-line",
    desc: "一句话怎么变成全网通用语，热梗的扩散路径观察。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20composition%20of%20overlapping%20speech%20bubble%20shapes%20in%20warm%20red%20and%20amber%20tones%20on%20cream%20background%2C%20minimal%20editorial%20graphic%20design%2C%20high%20detail&width=600&height=600&seq=cat-meme-01&orientation=squarish",
  },
];